import { c as _c } from "react/compiler-runtime";
import { useReCaptcha } from 'next-recaptcha-v3';
import { environment, hostEnv } from '@/globals/config/helpers/configEnvironment';
const awaitAnimationFrame = () => {
  return new Promise(resolve => {
    requestAnimationFrame(resolve);
  });
};
const fakeExecute = async () => 'NO.NO.NO.TOKEN';
export const useGoogleReCaptcha = () => {
  const $ = _c(2);
  const {
    executeRecaptcha
  } = useReCaptcha();
  if (process.env.NODE_ENV === "test") {
    return fakeExecute;
  }
  if ((environment !== "prd" || hostEnv === "localhost") && typeof window !== "undefined" && "Cypress" in window) {
    return fakeExecute;
  }
  let t0;
  if ($[0] !== executeRecaptcha) {
    t0 = async action => {
      await awaitAnimationFrame();
      return await executeRecaptcha(action);
    };
    $[0] = executeRecaptcha;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};